import { useEffect, useState } from "react";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { ConnectionStatus, UpdateNotice, useProgressSignal, watchNewVersion } from "@vixio/ui";

/**
 * Peças globais do app, fora das telas: linha de progresso ligada às consultas (só primeira carga e gravações; as
 * atualizações em segundo plano não acendem a barra), aviso de conexão e aviso de nova versão publicada.
 */
export function AppChrome() {
  const loading = useIsFetching({ predicate: (q) => q.state.status === "pending" });
  const saving = useIsMutating();
  useProgressSignal(loading + saving > 0);

  const [update, setUpdate] = useState(false);
  useEffect(() => watchNewVersion(() => setUpdate(true)), []);

  return (
    <>
      <ConnectionStatus />
      <UpdateNotice open={update} onReload={() => window.location.reload()} onDismiss={() => setUpdate(false)} />
    </>
  );
}
